/**
 * @generated SignedSource<<10028d55d8dc697933a78c258e25c0bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespPricingGuidanceInfo_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"estimatedValueFurnitureTestHelpers_item" | "pricingGuidanceTracking_item">;
  readonly " $fragmentType": "PdpRespPricingGuidanceInfo_item";
};
export type PdpRespPricingGuidanceInfo_item$key = {
  readonly " $data"?: PdpRespPricingGuidanceInfo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPricingGuidanceInfo_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespPricingGuidanceInfo_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "estimatedValueFurnitureTestHelpers_item"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceTracking_item",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceRange",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isTrade"
        },
        {
          "kind": "RootArgument",
          "name": "priceBookName"
        },
        {
          "kind": "RootArgument",
          "name": "userCountryCode"
        },
        {
          "kind": "RootArgument",
          "name": "userId"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "18ae07f0433185979e78da0f9ea5ed51";

export default node;
